import React from "react";
import { Button } from "react-md";
import successGif from "../../../../../../../assets/images/done-animation.gif";
import { formatCurrency } from "../cartPaymentLinkConstants";

/**
 * Terminal screen for a cart approve that needed no payment link: a synchronous
 * wallet debit, a refund, or a no-op (refund-only / zero-delta). Summarises the
 * money movement from the approve response delta and message. "Done" opens the
 * created appointment.
 */
const CartSuccessWithoutLink = ({ onDone, approveResponse }) => {
  const delta = approveResponse?.delta || {};
  const walletCollected = delta.wallet > 0 ? delta.wallet : 0;
  const walletRefund = delta.wallet < 0 ? -delta.wallet : 0;
  const externalRefund = delta.external < 0 ? -delta.external : 0;

  const lines = [];
  if (walletCollected > 0)
    lines.push({ label: "Debited from Wallet", amount: walletCollected });
  if (walletRefund > 0)
    lines.push({ label: "Refunded to Wallet", amount: walletRefund });
  if (externalRefund > 0)
    lines.push({ label: "Refunded to Razorpay", amount: externalRefund });

  const isRefund = walletRefund > 0 || externalRefund > 0;
  const title =
    isRefund && walletCollected === 0 ? "Refund initiated!" : "Cart approved!";

  return (
    <div className="pld-screen" style={{ textAlign: "center" }}>
      <div style={{ marginTop: "25px" }}>
        <img src={successGif} alt="success" height="150px" />
      </div>

      <div style={{ fontWeight: "bold", fontSize: "22px", marginTop: "10px" }}>
        {title}
      </div>

      {/* {lines.length > 0 && (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div
            className="show-shared-options-box zy-dashed-border"
            style={{ marginTop: "16px" }}
          >
            {lines.map((line, idx) => (
              <div
                key={idx}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "24px",
                }}
              >
                <span style={{ fontWeight: 500 }}>• {line.label}</span>
                <span style={{ fontWeight: 600 }}>
                  {formatCurrency(line.amount)}
                </span>
              </div>
            ))}
          </div>
        </div>
      )}

      {approveResponse?.message && (
        <div style={{ marginTop: "16px", color: "#555" }}>
          {approveResponse.message}
        </div>
      )} */}

      <div className="pld-center" style={{ marginTop: "25px" }}>
        <Button raised className="zy-btn-orange pld-main-btn" onClick={onDone}>
          Done
        </Button>
      </div>
    </div>
  );
};

export default CartSuccessWithoutLink;
